module.exports = __webpack_public_path__ + "img/dappcode.9b80abdf.png";